import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Counselling.css";
import { API_BASE_URL } from "./config";
import { useLoading } from "./LoadingContext";

export default function Counselling() {
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [calendarDays, setCalendarDays] = useState([]);
  const [slotsLoading, setSlotsLoading] = useState(false);

  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const [bookingId, setBookingId] = useState("");
  const [bookingDone, setBookingDone] = useState(false);

  const [paymentStarted, setPaymentStarted] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const isValidIndianMobile = (mobile) => /^[6-9]\d{9}$/.test(mobile);
  const [startBookingLoading, setStartBookingLoading] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);






  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

  const [formData, setFormData] = useState({
    fullName: "",
    studentType: "",
    dateOfBirth: "",
    mobile: "",
    email: "",
    city: "",
    goal: "",
    otp: "",
  });

  const studentTypes = [
    "10th / 12th Passed Student",
    "College Student",
    "Graduated Student",
    "Working Professional",
    "Parent Enquiry",
    "Other",
  ];

  const fetchAvailableSlots = async () => {
    try {
      setSlotsLoading(true);

      const response = await fetch(
        `${API_BASE_URL}/counselling/available-slots?days=90`
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.detail || "Unable to load counselling slots.");
        return;
      }

      if (data.status === "success") {
        const calendar = data.calendar || [];
        setCalendarDays(calendar);

        if (calendar.length > 0) {
          setSelectedDate(calendar[0].dateKey);
        }
      }
    } catch (error) {
      console.error("Slot loading error:", error);
      alert("Unable to load counselling slots.");
    } finally {
      setSlotsLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableSlots();
  }, []);

  const activeDay = useMemo(() => {
    return (
      calendarDays.find((day) => day.dateKey === selectedDate) ||
      calendarDays[0]
    );
  }, [calendarDays, selectedDate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let finalValue = value;

    if (name === "fullName") {
      finalValue = value.replace(/[^A-Za-z\s]/g, "").slice(0, 50);
    }

    if (name === "city") {
      finalValue = value.replace(/[^A-Za-z\s]/g, "").slice(0, 50);
    }

    if (name === "mobile") {
      finalValue = value.replace(/\D/g, "").slice(0, 10);
    }

    if (name === "email") {
      finalValue = value.trim().toLowerCase().slice(0, 100);
    }

    if (name === "otp") {
      finalValue = value.replace(/\D/g, "").slice(0, 4);
    }

    if (name === "goal") {
      finalValue = value.slice(0, 500);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    if (name === "email" || name === "mobile") {
      setOtpSent(false);
      setOtpVerified(false);
      setBookingId("");
      setPaymentSuccess(false);
      setBookingDone(false);
    }

    if (name === "otp") {
      setOtpVerified(false);
    }
  };

  const calculateAge = (dob) => {
    if (!dob) return 0;

    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  const isValidDOB = (dob) => {
    if (!dob) return false;

    const age = calculateAge(dob);

    return age >= 6 && age <= 80;
  };

  const mobileValid = isValidIndianMobile(formData.mobile);
  const emailValid = isValidEmail(formData.email);
  const dobValid = isValidDOB(formData.dateOfBirth);

  const getMissingFields = () => {
    const missing = [];

    if (!selectedSlot) missing.push("Please select counselling slot");

    if (!formData.fullName.trim()) {
      missing.push("Full Name is required");
    } else if (formData.fullName.trim().length < 2) {
      missing.push("Full Name must be at least 2 characters");
    }

    if (!formData.studentType) {
      missing.push("Current Status is required");
    }

    if (!formData.dateOfBirth) {
      missing.push("Date of Birth is required");
    } else if (!dobValid) {
      missing.push("Date of Birth must show age between 6 and 80 years");
    }

    if (!formData.mobile.trim()) {
      missing.push("Mobile Number is required");
    } else if (!mobileValid) {
      missing.push("Enter valid 10-digit mobile number starting with 6, 7, 8 or 9");
    }

    if (!formData.email.trim()) {
      missing.push("Email Address is required");
    } else if (!emailValid) {
      missing.push("Enter a valid email address");
    }

    if (!formData.city.trim()) {
      missing.push("City is required");
    } else if (formData.city.trim().length < 2) {
      missing.push("City must be at least 2 characters");
    }

    return missing;
  };

  // eslint-disable-next-line
  const canSendOtp =
    formData.fullName.trim().length >= 2 &&
    formData.studentType &&
    dobValid &&
    mobileValid &&
    emailValid &&
    formData.city.trim().length >= 2 &&
    selectedSlot;;

  const canBook =
    formData.fullName.trim().length >= 2 &&
    formData.studentType &&
    dobValid &&
    mobileValid &&
    emailValid &&
    formData.city.trim().length >= 2 &&
    selectedSlot &&
    otpVerified &&
    bookingId;


  const handleSendOtp = async () => {
    const missing = getMissingFields();

    if (missing.length > 0) {
      alert("Please complete the following:\n\n" + missing.join("\n"));
      return;
    }

    try {
      setStartBookingLoading(true);

      const response = await fetch(`${API_BASE_URL}/counselling/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          full_name: formData.fullName.trim(),
          student_type: formData.studentType,
          date_of_birth: formData.dateOfBirth,
          mobile: formData.mobile.trim(),
          email: formData.email.trim().toLowerCase(),
          city: formData.city.trim(),
          goal: formData.goal.trim(),
          counselling_date: selectedDate,
          slot_time: selectedSlot.time,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        const errorMessage =
          typeof data.detail === "object"
            ? data.detail.message
            : data.detail;

        alert(errorMessage || "Unable to send OTP.");
        await fetchAvailableSlots();
        return;
      }

      setBookingId(data.booking_id);
      setOtpSent(true);
      setOtpVerified(false);
      setShowOtpModal(true);
    } catch (error) {
      console.error("Send OTP error:", error);
      alert("Something went wrong while sending OTP.");
    } finally {
      setStartBookingLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!bookingId) {
      alert("Please send OTP first.");
      return;
    }

    if (!formData.otp.trim()) {
      alert("Please enter OTP.");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/counselling/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          booking_id: bookingId,
          email: formData.email.trim().toLowerCase(),
          otp: formData.otp.trim(),
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        alert(data.detail || "Invalid OTP.");
        await fetchAvailableSlots();
        return;
      }

      setOtpVerified(true);
      setShowOtpModal(false);
      setShowPaymentModal(true);
    } catch (error) {
      console.error("Verify OTP error:", error);
      alert("Something went wrong while verifying OTP.");
    }
  };

  const handleBookSlot = async () => {
    if (!canBook || !bookingId || !otpVerified) return;

    try {
      setPaymentStarted(true);
      setShowPaymentModal(false);

      showLoading("Confirming your free counselling slot...");

      const response = await fetch(
        `${API_BASE_URL}/counselling/confirm-free-booking`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            booking_id: bookingId,
            email: formData.email.trim().toLowerCase(),
            otp: formData.otp.trim(),
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(
          typeof data.detail === "string"
            ? data.detail
            : "Unable to confirm counselling slot."
        );

        setShowPaymentModal(true);
        await fetchAvailableSlots();
        return;
      }

      setBookingDone(true);
      setPaymentSuccess(true);
      setShowPaymentModal(false);

      await fetchAvailableSlots();

      setShowSuccessModal(true);

      setTimeout(() => {
        navigate("/");
      }, 10000);

    } catch (error) {
      console.error("Free counselling booking error:", error);
      alert("Unable to confirm counselling. Please try again.");
      setShowPaymentModal(true);

    } finally {
      setPaymentStarted(false);
      hideLoading();
    }
  };

  return (
    <main className="counselling-page">
      <section className="counselling-simple-hero">

        <div className="counselling-simple-inner">

          <p className="section-kicker">
            CAREER COUNSELLING
          </p>

          <h1>
            Know Exactly What to Do Next
          </h1>

          <p className="counselling-simple-intro">
            Book a one-to-one counselling session to understand your
            current level, right career direction, skill gaps and the
            next action you should take.
          </p>

          <div className="counselling-simple-points">

            <div>
              <span>01</span>
              <strong>Current Profile Assessment</strong>
            </div>

            <div>
              <span>02</span>
              <strong>Right Career Roadmap</strong>
            </div>

            <div>
              <span>03</span>
              <strong>Skill-Gap Clarity</strong>
            </div>

            <div>
              <span>04</span>
              <strong>Interview & Placement Direction</strong>
            </div>

          </div>

          <button
            className="counselling-hero-action"
            onClick={() => {
              document
                .getElementById("book-counselling")
                ?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
            }}
          >
            Book My Counselling →
          </button>

          <p className="counselling-guided-note">
            Personally guided based on your education, skills,
            experience and career goal.
          </p>

        </div>

      </section>

      <section
        className="counselling-section"
        id="book-counselling"
      >
        <div className="counselling-heading">
          <p className="section-kicker">BOOK COUNSELLING</p>
          <h2>Choose Your Counselling Slot</h2>
          <p>
            Select an available date and time, enter your details,
            verify your email and confirm the booking.
          </p>
        </div>

        <div className="booking-layout">
          <div className="booking-card calendar-card">
            <div className="booking-card-header">
              <span>01</span>
              <div>
                <h3>Select date</h3>
                <p>Next 3 months counselling calendar</p>
              </div>
            </div>

            {slotsLoading ? (
              <div className="selected-slot-box">
                <span>Loading Slots</span>
                <strong>Please wait...</strong>
              </div>
            ) : (
              <>
                <div className="date-scroll">
                  {calendarDays.map((day) => (
                    <button
                      key={day.dateKey}
                      className={
                        selectedDate === day.dateKey
                          ? "date-pill active"
                          : "date-pill"
                      }
                      onClick={() => {
                        setSelectedDate(day.dateKey);
                        setSelectedSlot(null);
                        setOtpSent(false);
                        setOtpVerified(false);
                        setBookingId("");
                        setBookingDone(false);
                        setPaymentSuccess(false);
                      }}
                    >
                      <span>{day.dayName}</span>
                      <strong>{day.dateText}</strong>
                    </button>
                  ))}
                </div>

                <div className="month-label">{activeDay?.monthText}</div>

                <div className="slot-grid">
                  {activeDay?.slots.map((slot) => (
                    <button
                      key={slot.id}
                      disabled={slot.status === "booked"}
                      className={[
                        "slot-card",
                        slot.status === "booked" ? "booked" : "available",
                        selectedSlot?.id === slot.id ? "selected" : "",
                      ].join(" ")}
                      onClick={() => {
                        setSelectedSlot(slot);
                        setOtpSent(false);
                        setOtpVerified(false);
                        setBookingId("");
                        setBookingDone(false);
                        setPaymentSuccess(false);
                      }}
                    >
                      <strong>{slot.time}</strong>
                      <span>
                        {slot.status === "booked"
                          ? "Already Booked"
                          : "Available"}
                      </span>
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>

          <div className="booking-card form-card">
            <div className="booking-card-header">
              <span>02</span>
              <div>
                <h3>Student details</h3>
                <p>Required before booking confirmation</p>
              </div>
            </div>

            <div className="selected-slot-box">
              <span>Selected Slot</span>
              <strong>
                {selectedSlot
                  ? `${activeDay?.dateText} • ${selectedSlot.time}`
                  : "Please select an available slot"}
              </strong>
            </div>

            <div className="form-grid">
              <label>
                <span className="field-label">
                  Full Name <em>*</em>
                </span>
                {/* <input
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter student name"
                  disabled={paymentSuccess}
                /> */}

                <input
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  placeholder="Enter student name"
                  maxLength={50}
                  disabled={paymentSuccess}
                />
              </label>

              <label>
                <span className="field-label">
                  Current Status <em>*</em>
                </span>
                <select
                  name="studentType"
                  value={formData.studentType}
                  onChange={handleChange}
                  disabled={paymentSuccess}
                >
                  <option value="">Select status</option>
                  {studentTypes.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </label>

              <label>
                <span className="field-label">
                  Date of Birth <em>*</em>
                </span>
                <input
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  min="1945-01-01"
                  max={new Date(
                    new Date().setFullYear(new Date().getFullYear() - 6)
                  )
                    .toISOString()
                    .split("T")[0]}
                  className="dob-input-highlight"
                  disabled={paymentSuccess}
                />

                <small className="field-helper dob-helper">
                  Select proper <b>Date / Month / Year</b>. Student age must be minimum 6 years.
                </small>

                {formData.dateOfBirth && !dobValid && (
                  <small className="field-error">
                    Student age must be between 6 and 80 years.
                  </small>
                )}
              </label>

              <label>
                <span className="field-label">
                  Mobile Number <em>*</em>
                </span>
                <input
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="10-digit mobile number"
                  inputMode="numeric"
                  maxLength={10}
                  disabled={paymentSuccess}
                />
                {formData.mobile && !mobileValid && (
                  <small className="field-error">
                    Enter valid 10-digit mobile number starting with 6, 7, 8 or
                    9.
                  </small>
                )}
              </label>

              <label>
                <span className="field-label">
                  Email Address <em>*</em>
                </span>
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email for OTP"
                  maxLength={100}
                  disabled={paymentSuccess}
                />
                {formData.email && !emailValid && (
                  <small className="field-error">
                    Enter a valid email address.
                  </small>
                )}
              </label>

              <label>
                <span className="field-label">
                  City <em>*</em>
                </span>
                <input
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Enter city"
                  maxLength={50}
                  disabled={paymentSuccess}
                />
              </label>
            </div>

            <label className="goal-field">
              <span className="field-label">
                What do you want to discuss?
                <span className="optional-text">Optional</span>
              </span>
              <textarea
                name="goal"
                value={formData.goal}
                onChange={handleChange}
                placeholder="Optional: You can share your goal, confusion, education status, career target, or any question you want to discuss."
                maxLength={500}
                disabled={paymentSuccess}
              />

              <small className="field-helper">
                {formData.goal.length}/500 characters
              </small>
            </label>








            {bookingDone && (
              <div className="success-booking-message">
                <strong>Slot booked successfully.</strong>
                <p>
                  Your counselling slot has been confirmed. Confirmation details
                  have been sent to your registered email.
                </p>
              </div>
            )}

            {!bookingDone && bookingId && otpSent && !paymentSuccess && (
              <div className="success-booking-message">
                <strong>Your details are saved.</strong>
                <p>
                  Please verify your email OTP to confirm the selected
                  counselling slot.
                </p>
              </div>
            )}
          </div>
        </div>


        <div className="counselling-bottom-action">
          <button
            className="confirm-booking-btn counselling-main-action"
            onClick={handleSendOtp}
            disabled={startBookingLoading || paymentSuccess}
          >
            {startBookingLoading
              ? "Sending OTP..."
              : "Continue to Email Verification"}
          </button>
        </div>

        {showOtpModal && (
          <div className="counselling-modal-overlay">
            <div className="counselling-modal-box">
              <button
                className="counselling-modal-close"
                onClick={() => setShowOtpModal(false)}
              >
                ×
              </button>

              <h2>Email Verification Required</h2>

              <p>
                We have saved your counselling details and sent an OTP to your email.
              </p>

              <p>
                Please enter the OTP below to verify your email and continue to the
                free counselling booking step.
              </p>

              <div className="counselling-otp-input-wrap">
                <input
                  name="otp"
                  value={formData.otp}
                  onChange={handleChange}
                  placeholder="Enter OTP"
                  maxLength={4}
                  inputMode="numeric"
                  className="counselling-otp-input"
                />
              </div>

              <button
                className="confirm-booking-btn"
                onClick={handleVerifyOtp}
                disabled={formData.otp.trim().length !== 4 || otpVerified}
              >
                {otpVerified ? "Verified" : "Verify OTP"}
              </button>
            </div>
          </div>
        )}

        {showPaymentModal && !paymentStarted && !showSuccessModal && (
          <div className="counselling-modal-overlay">
            <div className="counselling-modal-box counselling-payment-modal">
              <button
                className="counselling-modal-close"
                onClick={() => setShowPaymentModal(false)}
              >
                ×
              </button>

              <h2>Confirm Counselling Slot</h2>

              <p>
                Your email is verified successfully. Complete the free counselling
                booking to confirm your selected slot.
              </p>

              <div className="counselling-payment-summary">
                <div>
                  <span>Selected Date</span>
                  <strong>{activeDay?.dateText}</strong>
                </div>

                <div>
                  <span>Selected Time</span>
                  <strong>{selectedSlot?.time}</strong>
                </div>

                <div>
                  <span>Counselling Fee</span>
                  <strong>FREE · ₹0</strong>
                </div>
              </div>

              <button
                className="confirm-booking-btn"
                onClick={handleBookSlot}
                disabled={paymentStarted || bookingDone}
              >
                {paymentStarted
                  ? "Confirming Your Slot..."
                  : "Confirm Free Counselling Slot"}
              </button>
            </div>
          </div>
        )}

        {showSuccessModal && (
          <div className="counselling-modal-overlay">
            <div className="counselling-modal-box counselling-success-modal">
              <div className="counselling-success-icon">✓</div>

              <h2>Counselling Slot Confirmed</h2>

              <p>
                Your free counselling appointment has been successfully booked and your slot is
                now confirmed.
              </p>

              <div className="counselling-payment-summary">
                <div>
                  <span>Selected Date</span>
                  <strong>{activeDay?.dateText}</strong>
                </div>

                <div>
                  <span>Selected Time</span>
                  <strong>{selectedSlot?.time}</strong>
                </div>

                <div>
                  <span>Email</span>
                  <strong>{formData.email}</strong>
                </div>
              </div>

              <p>
                Confirmation details and counselling information have been sent to your
                registered email.
              </p>

              <p className="counselling-redirect-note">
                Redirecting to home page in 10 seconds...
              </p>

              <button
                className="confirm-booking-btn"
                onClick={() => navigate("/")}
              >
                Go to Home Now
              </button>
            </div>
          </div>
        )}
      </section>

      <section className="counselling-section counselling-info-section">
        <div className="info-grid">
          <div className="info-card">
            <span>01</span>
            <h3>Personal attention</h3>
            <p>
              The student’s current stage, family background, discipline,
              learning ability and career thought process are understood before
              suggesting the roadmap.
            </p>
          </div>

          <div className="info-card">
            <span>02</span>
            <h3>Clear career direction</h3>
            <p>
              Students get clarity about AI, Data Science, Software Development,
              projects, interview preparation and long-term career planning.
            </p>
          </div>

          <div className="info-card">
            <span>03</span>
            <h3>Serious student filter</h3>
            <p>
              Counselling helps identify whether the student is ready to study
              hard, stay disciplined, and follow a structured upskilling system.
            </p>
          </div>
        </div>

        <div className="back-home-box">
          <h2>Not sure which roadmap is right?</h2>
          <p>
            That is exactly why counselling exists. Choose a slot and discuss
            the right path before starting.
          </p>
          <button onClick={() => navigate("/")}>Back to Home</button>
        </div>
      </section>
    </main>
  );
}